import { useState, useEffect } from "react";

import {
  faCaretLeft,
  faCaretRight,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Radium, { StyleRoot } from "radium";
import { fadeInRightBig } from "react-animations";
import { Img } from "react-image";
import Slider from "react-slick";
import Carousel, { Modal, ModalGateway } from "react-images";
import Media, { useMediaQuery } from "react-responsive";

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
//un import por imagen
import idilioVistania1 from "./../../assets/images2/realEstate/idilioVistania/img1.webp";
import idilioVistania2 from "./../../assets/images2/realEstate/idilioVistania/img2.webp";
import idilioVistania3 from "./../../assets/images2/realEstate/idilioVistania/img3.webp";
import idilioVistania4 from "./../../assets/images2/realEstate/idilioVistania/img4.webp";
import idilioVistania5 from "./../../assets/images2/realEstate/idilioVistania/img5.webp";
import idilioVistania6 from "./../../assets/images2/realEstate/idilioVistania/img6.webp";
import idilioVistania7 from "./../../assets/images2/realEstate/idilioVistania/img7.webp";
import idilioVistania8 from "./../../assets/images2/realEstate/idilioVistania/img8.webp";
import idilioVistania9 from "./../../assets/images2/realEstate/idilioVistania/img9.webp";
import idilioVistania10 from "./../../assets/images2/realEstate/idilioVistania/img10.webp";
import idilioVistania11 from "./../../assets/images2/realEstate/idilioVistania/img11.webp";
import idilioVistania12 from "./../../assets/images2/realEstate/idilioVistania/img12.webp";
import "./sass/index.scss";

const imagesIdilioVistania = [
  idilioVistania1,
  idilioVistania2,
  idilioVistania3,
  idilioVistania4,
  idilioVistania5,
  idilioVistania6,
  idilioVistania7,
  idilioVistania8,
  idilioVistania9,
  idilioVistania10,
  idilioVistania11,
  idilioVistania12,
];

const widths = [
  540, 540, 540, 540, 920, 1100, 1200, 920, 1200, 1100, 1200, 1100,
];

const styles = {
  fadeInRightBig: {
    animation: "x 1s",
    animationName: Radium.keyframes(fadeInRightBig, "fadeInRightBig"),
  },
};

const Gallery = () => {
  const [itemsGallery, setItemsGallery] = useState<
    { img: string; width: string }[]
  >([]);
  const [itemsModal, setItemsModal] = useState<
    { source: string; id: number }[]
  >([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const isTablet = useMediaQuery({ query: "(max-width: 1224px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 600px)" });

  useEffect(() => {
    const ratio = isMobile ? 0.27 : isTablet ? 0.55 : 0.69;
    const gallery = imagesIdilioVistania.map((v, index) => {
      return {
        img: v,
        width: `${Math.floor(widths[index] * ratio)}px`,
      };
    });

    const modal = imagesIdilioVistania.map((v, index) => {
      return {
        source: v,
        id: index,
      };
    });

    setItemsGallery(gallery);
    setItemsModal(modal);
  }, []);

  const settings = {
    className: "slider variable-width",
    centerMode: itemsGallery.length > 1 ? true : false,
    infinite: false,
    centerPadding: itemsGallery.length > 1 ? "40px" : "",
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1500,
    variableWidth: true,
    lazyLoad: "ondemand" as const,
    prevArrow: (
      <button>
        <FontAwesomeIcon icon={faCaretLeft} />
      </button>
    ),
    nextArrow: (
      <button>
        <FontAwesomeIcon icon={faCaretRight} />
      </button>
    ),
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          centerPadding: itemsGallery.length > 1 ? "0px" : "",
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: itemsGallery.length > 1 ? "0px" : "",
        },
      },
    ],
  };

  return (
    <StyleRoot>
      <div className="cont-about">
        <div className="cont-gallery" style={styles.fadeInRightBig}>
          {itemsGallery.length > 0 && (
            <Slider key={itemsGallery.length} {...settings}>
            {itemsGallery.map(({ img, width }, index) => (
              <div
                className="item"
                key={index}
                style={{ width: width }}
                onClick={() => {
                  setCurrentIndex(index);
                  setModalIsOpen(true);
                }}
              >
                <div className="cont-img-slide">
                  <Img
                    src={img}
                    alt=""
                    loader={
                      <div className="loader-image">
                        <FontAwesomeIcon icon={faSpinner} pulse />
                      </div>
                    }
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </Slider>
          )}
          <Media maxWidth="768px">
            <ModalGateway>
              {modalIsOpen ? (
                <Modal onClose={() => setModalIsOpen(false)}>
                  <Carousel views={itemsModal} currentIndex={currentIndex} />
                </Modal>
              ) : null}
            </ModalGateway>
          </Media>
        </div>
      </div>
    </StyleRoot>
  );
};

export default Gallery;
